import { useEffect, useState } from "react";
import { getMasterCompanies } from "../../../api/masterCompany.api";

export function useMasterCompany() {
  const [masterCompanies, setMasterCompanies] = useState([]); 
  const [loadingMaster, setloadingMaster] = useState(false);

  const loadOrganizers = async () => {
    setloadingMaster(true);
    try {
      const res = await getMasterCompanies();
      setMasterCompanies(res?.data || []);
    } catch (e) {
      setMasterCompanies([]);
    } finally {
      setloadingMaster(false);
    }
  };

  useEffect(() => {
    loadOrganizers();
  }, []);

  return { masterCompanies, loadingMaster };
}
